module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('h5', [_vm._v("Bucket name")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      input: true,
        'is-danger': _vm.errors.has('bname'),
    },
    attrs: {
      "data-vv-delay": "200",
      "name": "bname",
      "type": "text",
      "placeholder": "Bucket Name"
    },
    model: {
      value: (_vm.formData.bname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "bname", $$v)
      },
      expression: "formData.bname"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bname')),
      expression: "errors.has('bname')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('bname')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Select Countries")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "change": _vm.disable(_vm.formData.country),
      "placeholder": "Select country",
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.country),
      callback: function($$v) {
        _vm.$set(_vm.formData, "country", $$v)
      },
      expression: "formData.country"
    }
  }, _vm._l((_vm.countries), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option.name,
        "value": option.id,
        "disabled": _vm.displayexistingCountries.indexOf(option.id) > -1
      }
    })
  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Associate Products")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select products"
    },
    model: {
      value: (_vm.formData.prod),
      callback: function($$v) {
        _vm.$set(_vm.formData, "prod", $$v)
      },
      expression: "formData.prod"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "Select a product",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.products), function(prod) {
    return _c('el-option', {
      key: prod.id,
      attrs: {
        "label": prod.name,
        "value": prod.id
      }
    })
  })], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": !_vm.formData.isMobileEnable
    },
    on: {
      "change": _vm.loadExistingCountries
    },
    model: {
      value: (_vm.formData.isMobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isMobile", $$v)
      },
      expression: "formData.isMobile"
    }
  }, [_vm._v("Mobile enabled?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": !_vm.formData.isWebEnable
    },
    on: {
      "change": _vm.loadExistingCountries
    },
    model: {
      value: (_vm.formData.isWeb),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isWeb", $$v)
      },
      expression: "formData.isWeb"
    }
  }, [_vm._v("Web enabled?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": !_vm.formData.isTabletEnable
    },
    on: {
      "change": _vm.loadExistingCountries
    },
    model: {
      value: (_vm.formData.isTablet),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isTablet", $$v)
      },
      expression: "formData.isTablet"
    }
  }, [_vm._v("Tablet enabled?")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-left",
    class: {
      'el-icon-edit': _vm.bucketId !== undefined,
        'el-icon-plus': _vm.bucketId === undefined,
    }
  }), _vm._v("\n                            " + _vm._s(_vm.bucketId === undefined ? 'Create Bucket' : 'Edit Bucket') + "\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--danger",
    attrs: {
      "to": ("" + ('/admin/publisher/' + _vm.uuid + '/domain/edit/' + _vm.domId + '/'))
    }
  }, [_vm._v("\n                            Cancel\n                        ")])], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Create/Edit Bucket")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36b35114!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/DomainBucket.vue
// module id = 675
// module chunks = 2